var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5789,
    cy: 8.11495,
    r: 4.77803,
    stroke: "#FFD456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00002 19.5382C3.99873 19.2023 4.07385 18.8706 4.2197 18.568C4.67736 17.6526 5.96798 17.1675 7.03892 16.9478C7.81128 16.783 8.59431 16.6729 9.38217 16.6183C10.8408 16.4902 12.3079 16.4902 13.7666 16.6183C14.5544 16.6735 15.3374 16.7836 16.1099 16.9478C17.1808 17.1675 18.4714 17.6069 18.9291 18.568C19.2224 19.1848 19.2224 19.9008 18.9291 20.5176C18.4714 21.4787 17.1808 21.9181 16.1099 22.1286C15.3384 22.3003 14.5551 22.4135 13.7666 22.4673C12.5794 22.5679 11.3866 22.5863 10.1968 22.5222C9.92221 22.5222 9.65677 22.5222 9.38217 22.4673C8.59663 22.4141 7.81632 22.3009 7.04807 22.1286C5.96798 21.9181 4.68652 21.4787 4.2197 20.5176C4.0746 20.2115 3.99955 19.877 4.00002 19.5382Z",
    stroke: "#FFD456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileYellow);
export default __webpack_public_path__ + "static/media/profile-yellow.4ea2bbdb656f52675a19754fc75e718f.svg";
export { ForwardRef as ReactComponent };